module.exports = __webpack_public_path__ + "img/samsung_combo1_1280.9fb9beb1.png";